import {useEffect, useMemo} from 'react';

import {recordRumAction} from '../../../util/datadog/datadogRum';
import {
  useStatsigGateBackendLineConstruction,
  useStatsigGateBackendLineConstructionGrouped,
  useStatsigGateBackendLineConstructionReports,
  useStatsigGateBackendLineConstructionSmoothing,
  useStatsigGateBackendLineConstructionTimeUnits,
} from '../../../util/rampFeatureFlags/linePlotFeatureFlags';

export type BackendLineConstructionFlags = {
  canUseBackendLineConstruction: boolean;
  canUseBackendLineConstructionGrouped: boolean;
  canUseBackendLineConstructionInReports: boolean;
  canUseBackendLineConstructionSmoothing: boolean;
  canUseBackendLineConstructionTimeUnits: boolean;
};

export const useBackendLineConstruction = (): BackendLineConstructionFlags => {
  const canUseBackendLineConstruction = useStatsigGateBackendLineConstruction();
  const canUseBackendLineConstructionGrouped =
    useStatsigGateBackendLineConstructionGrouped();
  const canUseBackendLineConstructionInReports =
    useStatsigGateBackendLineConstructionReports();
  const canUseBackendLineConstructionSmoothing =
    useStatsigGateBackendLineConstructionSmoothing();
  const canUseBackendLineConstructionTimeUnits =
    useStatsigGateBackendLineConstructionTimeUnits();

  // track
  useEffect(() => {
    recordRumAction('Backend Line Construction: Panel Load', {
      useBackendLineConstruction: canUseBackendLineConstruction,
      useBackendLineConstructionGrouped: canUseBackendLineConstructionGrouped,
      useBackendLineConstructionInReports:
        canUseBackendLineConstructionInReports,
      useBackendLineConstructionSmoothing:
        canUseBackendLineConstructionSmoothing,
      useBackendLineConstructionTimeUnits:
        canUseBackendLineConstructionTimeUnits,
    });
  }, [
    canUseBackendLineConstruction,
    canUseBackendLineConstructionGrouped,
    canUseBackendLineConstructionInReports,
    canUseBackendLineConstructionSmoothing,
    canUseBackendLineConstructionTimeUnits,
  ]);

  return useMemo(
    () => ({
      canUseBackendLineConstruction,
      canUseBackendLineConstructionGrouped,
      canUseBackendLineConstructionInReports,
      canUseBackendLineConstructionSmoothing,
      canUseBackendLineConstructionTimeUnits,
    }),
    [
      canUseBackendLineConstruction,
      canUseBackendLineConstructionGrouped,
      canUseBackendLineConstructionInReports,
      canUseBackendLineConstructionSmoothing,
      canUseBackendLineConstructionTimeUnits,
    ]
  );
};
